import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, staggerContainer, WHATSAPP_URL } from '../utils/constants';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center pt-20 bg-grayLightest" data-id="element-108">
      <div className="max-w-7xl mx-auto px-6 relative z-10 w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-109">
        <motion.div variants={staggerContainer} initial="hidden" animate="visible" className="max-w-2xl" data-id="element-110">
          <motion.div variants={fadeUp} className="flex items-center gap-4 mb-6" data-id="element-111">
            <div className="h-px w-12 bg-grayDarkest" data-id="element-112"></div>
            <span className="font-montserrat text-grayDarkest tracking-[0.2em] text-sm uppercase font-semibold" data-id="element-113">
              Defensa Legal de Élite
            </span>
          </motion.div>

          <motion.div variants={fadeUp} data-id="element-114">
            <h1 className="heading-brutalist text-5xl md:text-7xl lg:text-8xl leading-[1.1] mb-8 text-grayDarkest" data-id="element-115">
              <span className="lowercase font-light block mb-2" data-id="element-116">
                tu derecho,
              </span>
              NUESTRA MISIÓN
            </h1>
          </motion.div>

          <motion.p variants={fadeUp} className="text-lg md:text-xl text-grayDarkest max-w-xl mb-12 leading-relaxed font-light" data-id="element-117">
            Más de 20 años protegiendo los intereses de nuestros clientes con
            estrategia, determinación y resultados comprobados.
          </motion.p>

          <motion.div variants={fadeUp} className="flex flex-col sm:flex-row gap-6" data-id="element-118">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="bg-grayDarkest text-white px-8 py-4 font-montserrat font-semibold uppercase tracking-wider hover:bg-grayMedium transition-all duration-300 text-center flex items-center justify-center gap-2 group" data-id="element-119">
              protege tus DERECHOS HOY
              <span className="group-hover:translate-x-1 transition-transform" data-id="element-120">
                →
              </span>
            </a>
            <a href="#areas" className="border border-grayDarkest text-grayDarkest px-8 py-4 font-montserrat font-semibold uppercase tracking-wider hover:bg-grayDarkest hover:text-white transition-all duration-300 text-center" data-id="element-121">
              Conozca Nuestras Áreas
            </a>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="hidden lg:block h-[600px] w-full relative" data-id="element-122">
          <img src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80" alt="Justicia" className="w-full h-full object-cover shadow-2xl" data-id="element-123" />
          <div className="absolute inset-0 border border-grayMid m-4 pointer-events-none" data-id="element-124"></div>
        </motion.div>
      </div>

      {/* Stats Bar */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1,
      duration: 0.8
    }} className="absolute bottom-0 left-0 right-0 border-t border-grayMid bg-white" data-id="element-125">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-wrap justify-between gap-8" data-id="element-126">
          {[{
          value: '500+',
          label: 'Casos Resueltos'
        }, {
          value: '98%',
          label: 'Tasa de Éxito'
        }, {
          value: '20+',
          label: 'Años de Experiencia'
        }, {
          value: '150+',
          label: 'Clientes Activos'
        }].map((stat, i) => <div key={i} className="flex flex-col" data-id="element-127">
              <span className="font-montserrat text-3xl font-bold text-grayDarkest" data-id="element-128">
                {stat.value}
              </span>
              <span className="text-xs text-grayMedium uppercase tracking-wider mt-1 font-semibold" data-id="element-129">
                {stat.label}
              </span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}